module.exports = __webpack_public_path__ + "static/img/blog_banner_logo.1717de0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/icon/svg/blog_banner_logo.svg
// module id = tg7o
// module chunks = 8